(function () {
  const carousels = document.querySelectorAll("[data-product-carousel]");
  if (!carousels.length) return;

  carousels.forEach((root) => {
    const slides = Array.from(root.querySelectorAll("[data-carousel-slide]"));
    if (slides.length <= 1) return;

    const prev = root.querySelector("[data-carousel-prev]");
    const next = root.querySelector("[data-carousel-next]");
    const dotsHost = root.querySelector("[data-carousel-dots]");
    let index = slides.findIndex((slide) => slide.classList.contains("is-active"));
    if (index < 0) index = 0;

    const dots = slides.map((_, i) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "carousel-dot";
      dot.setAttribute("role", "tab");
      dot.setAttribute("aria-label", `Image ${i + 1} of ${slides.length}`);
      dot.addEventListener("click", () => goTo(i));
      dotsHost?.append(dot);
      return dot;
    });

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-hidden", active ? "false" : "true");
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-selected", active ? "true" : "false");
      });
    }

    prev?.addEventListener("click", () => goTo(index - 1));
    next?.addEventListener("click", () => goTo(index + 1));

    root.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        goTo(index - 1);
      }
      if (event.key === "ArrowRight") {
        event.preventDefault();
        goTo(index + 1);
      }
    });

    let pointerStartX = null;
    const viewport = root.querySelector(".carousel-viewport");
    viewport?.addEventListener("pointerdown", (event) => {
      pointerStartX = event.clientX;
    });
    viewport?.addEventListener("pointerup", (event) => {
      if (pointerStartX === null) return;
      const delta = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(delta) < 40) return;
      goTo(delta < 0 ? index + 1 : index - 1);
    });

    goTo(index);
  });
})();
